<template>
    <v-container fluid class="red-cards-table p-0">
        <v-data-table
            :rows-per-page-items="[25,50,100]"
            :headers="headers"
            :items="currentRedCards"
            class="elevation-1 responsive-table-sm"
            light
            hide-actions
            no-results-text="">
            <template slot="headerCell" slot-scope="props">
              <v-tooltip left v-if="props.header.tooltip">
                <span slot="activator">
                  {{ props.header.text }}
                </span>
                <span>
                  {{ props.header.desc }}
                </span>
              </v-tooltip>
              <span v-else>{{ props.header.text }}</span>
            </template>

            <template slot="items" slot-scope="props">
                <td class="text-md-right text-xs-center">{{ props.item.position }}</td>
                <td class="text-md-right text-xs-left sticky-cell">
                  <span class="px-2 crop-text">
                    {{ props.item.name }}
                  </span>
                </td>
                <td class="text-xs-right">{{ props.item.team_name }}</td>
                <td class="text-xs-right">{{ props.item.attendances }}</td>
                <td class="text-xs-right">{{ props.item.red_cards }}</td>
            </template>
        </v-data-table>
    </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Utils from '@/utils/utils'
    export default {
        name:'ScorersTable',
        props: {
          tournamentid:{required: true, default: -1}
        },
        data() {
            return {
                headers: [
                    { text: '#', value: 'position', tooltip: false, desc: '#' },
                    { text: 'Jugador', value: 'player', tooltip: false, desc: 'Jugador' },
                    { text: 'Equipo', value: 'team', tooltip: false, desc: 'Equipo' },
                    { text: 'JJ', value: 'games', tooltip: true, desc: 'Juegos Jugados' },
                    { text: 'TR', value: 'rCards', tooltip: true, desc: 'Tarjetas Rojas' }
                ]
            }
        },
        created() {
          //do something after creating vue instance
          if(this.tournamentid > 0){
            this.loadRedCards(this.tournamentid)
          }
        },
        methods: {
          ...mapActions([
            'loadRedCards'
          ])
        },
        computed:{
          ...mapGetters([
            'currentRedCards'
          ])
        },
        mounted() {
          Utils.setTableOverflowClass('.red-cards-table .responsive-table-sm');
        },
    }
</script>

<style lang="scss">
@import "src/assets/scss/tables-placeholder-selectors";
.p-0 {
  padding: 0;
}

.red-cards-table {
  th:nth-child(2),
  .sticky-cell {
    @extend %sticky-cell;
    top: auto;
    left: 0;
  }

  .has-scroll th:nth-child(2),
  .has-scroll .sticky-cell {
    @extend %sticky-cell-has-shadow;
  }
}

@media screen and (max-width: $mobile-md-breakpoint) {
  .red-cards-table {
    // id column
    .datatable.table th:first-child,
    .datatable.table td:first-child {
      max-width: 45px;
      width: 45px;
    }

    .datatable.table th:nth-child(2) {
      padding-right: 8px;
    }
    table.datatable th:not(:first-child):not(:nth-child(2)):not(:nth-child(3)) {
      text-align: center !important; // override library styles
    }

    .table th:nth-child(2),
    .table th:nth-child(3) {
      text-align: left !important; // override library styles
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/tournaments/statistics/RedCardsTable.vue